// @flow

// Action Type
import * as actionTypesAppt from 'store/reducers/appointment/actionTypes';
import * as contactInfoTypes from 'store/reducers/appointment/contactInfo/actions';
import * as actionTypesPromotions from 'store/reducers/promotions/actionTypes';
import * as actionTypesValetDetails from 'store/reducers/appointment/valetDetails/actions';
import * as actionTypes from 'store/actionTypes';

// Actions
import { apptModified } from 'store/reducers/userInteractions/actions';
import { resetPromotion } from 'store/reducers/promotions/actions';

// Selectors
import { isModifyEnabled } from 'store/reducers/userInteractions/selectors';
import {
  getTransportOptions,
  getAdvisors
} from 'store/reducers/apptOptions/selectors';
import { getDefaultPromo } from 'store/reducers/marketing/selectors';
// types
import type { Store, Action } from 'types/redux';
import { SET_MOBILE_NUMBER_MODIFIED } from 'store/reducers/userInteractions/actionTypes';

export const modifyApptMiddleware = (store: Store) => (
  next: (action: Action) => any
) => (action: any) => {
  switch (action.type) {
    case actionTypesAppt.SET_TRANSPORTATION_OPTION:
      {
        const transportations = getTransportOptions(store.getState());
        if (isModifyEnabled(store.getState()) && transportations.length > 1) {
          store.dispatch(apptModified());
        }
      }
      break;
    case actionTypesAppt.SET_ADVISOR:
      {
        const advisors = getAdvisors(store.getState());
        if (isModifyEnabled(store.getState()) && advisors.length > 1) {
          store.dispatch(apptModified());
        }
      }
      break;
    case actionTypes.RESET_APP_STATE:
    case actionTypesAppt.RESET_APPT:
      if (!getDefaultPromo(store.getState())) {
        store.dispatch(resetPromotion());
      }
      break;
    case actionTypesAppt.SET_START_TIME:
    case actionTypesAppt.SET_ATTENDANCE_STATUS:
    case actionTypesAppt.SET_PARTICIPANT_COMMENTS:
    case contactInfoTypes.SET_FIRST_NAME:
    case contactInfoTypes.SET_LAST_NAME:
    case contactInfoTypes.SET_EMAIL:
    case contactInfoTypes.SET_PHONE:
    case actionTypesAppt.SET_MILEAGE:
    case actionTypesAppt.SET_SERVICES:
    case actionTypesAppt.REMOVE_SERVICE:
    case actionTypesAppt.UPDATE_TELLUSMORE_SERVICE:
    case actionTypesAppt.UPDATE_SERVICE_COMMENT:
    case actionTypesAppt.ADD_DECLINED_SERVICE:
    case actionTypesAppt.REMOVE_DECLINED_SERVICE:
    case actionTypesAppt.SET_PRIVACY_SETTINGS:
    case actionTypesAppt.SET_APPT_SERVICE_POINT:
    case SET_MOBILE_NUMBER_MODIFIED:
    case actionTypesAppt.SET_CALL_BACK:
    case actionTypesAppt.SET_LICENSE_NUMBER:
    case actionTypesValetDetails.SET_DROP_OFF_ADDRESS:
    case actionTypesValetDetails.SET_PICK_UP_ADDRESS:
    case actionTypesValetDetails.SET_VALET_COMMENTS:
    case actionTypesValetDetails.SET_DROPOFF_PREFERENCE:
    case actionTypesPromotions.SET_PROMOTION:
      if (isModifyEnabled(store.getState())) {
        store.dispatch(apptModified());
      }
      break;
    default:
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/store/middlewares/modify-appt-middleware.js